import {Outlet} from 'react-router-dom';

import {
    PlatformAppShell,
    PlatformFooter,
    PlatformHeader,
    PlatformHeaderNavigationMenu,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Suspense} from "react";

export const PublicLayout = () => {

    const menuItems = [] as { title: string, onClick: () => void }[]

    return <PlatformAppShell
        platformHeader={<PlatformHeader
            navigationMenu={<PlatformHeaderNavigationMenu menuItems={menuItems}/>}/>}
        platformFooter={<PlatformFooter/>}
    >
        <Suspense fallback={<PlatformLoader/>}>
            <Outlet/>
        </Suspense>
    </PlatformAppShell>


};
